import React, { Component } from 'react';
import './index.css';

class Map extends Component {
    render() {
        return (
            <div className="map-content">
                <h2>Where We Serve</h2>
                <div className="seperator-map" />
                <div className="map-container">
                    <div className="map-item">
                        <img src="./images/south_america.svg" alt="Map of South America" />
                        <div className="served-locations">
                            <p>Valencia, Venezuela <span className="light-blue">(</span>SA<span className="light-blue">)</span></p>
                            <p>Medellin, Colombia <span className="light-blue">(</span>SA<span className="light-blue">)</span></p>
                            <p>Bogota, Colombia <span className="light-blue">(</span>SA<span className="light-blue">)</span></p>
                            <p>Quito, Ecuador <span className="light-blue">(</span>SA<span className="light-blue">)</span></p>
                            <p>Santo Domingo, Ecuador <span className="light-blue">(</span>SA<span className="light-blue">)</span></p>
                        </div>
                    </div>
                    <div className="affiliate">
                        <h3>Located In Latin America?</h3>
                        <p>Check Out Our Affiliates at <a href="https://www.industrialservices.ec"><span style={{color: '#19A0C5'}}>Industrial Services!</span></a></p>
                    </div>
                    <div className="map-item">
                        <img src="./images/north_america.svg" alt="Map of North America" />
                        <div className="served-locations">
                            <p>Regina, Saskatchewan <span className="light-blue">(</span>CA<span className="light-blue">)</span></p>
                            <p>Seattle, Washington <span className="light-blue">(</span>US<span className="light-blue">)</span></p>
                            <p>Edmonton, Alberta <span className="light-blue">(</span>CA<span className="light-blue">)</span></p>
                            <p>Greater Sudbury, Ontario <span className="light-blue">(</span>CA<span className="light-blue">)</span></p>
                            <p>Indianapolis, Indiana <span className="light-blue">(</span>US<span className="light-blue">)</span></p>
                            <p>Orlando, Florida <span className="light-blue">(</span>US<span className="light-blue">)</span></p>
                            <p>Dallas, Texas <span className="light-blue">(</span>US<span className="light-blue">)</span></p>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}
export default Map;
